//@flow
import React from 'react';
import ContentRouter from "../../routers/contentRouter";
import NewAuthBackgroundImage from "../../../src/assets/images/components/newAuthBackgroundImage"
import { useLocation } from 'react-router-dom';

export const TitleContext = React.createContext(null)

const Content = () => {
	const location = useLocation();
	const pageClass = location.pathname.replace(/\//g, '-').substring(1); 

	const [title, setTitle] = React.useState(null)
	const [toolbarBottom, setToolbarBottom] = React.useState(null)
	const [menuNavigation, setMenuNavigation] = React.useState(null)
	return (
		<TitleContext.Provider
			value={{
				title: title,
				setTitle: setTitle,
				toolbar: toolbarBottom,
				setToolbar: setToolbarBottom,
				menuNavigation,
				setMenuNavigation
			}}
		>
			<div style={{ fontFamily: 'IMS' }} className={`force-ims page-${pageClass}`}>
				<NewAuthBackgroundImage /> 
				<ContentRouter/>
			</div>
		</TitleContext.Provider>
	)
}

export default Content;
